import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeedbackApiBase } from './feedback-api-base';
import { DataEnvelope, FeedbackAuditRun, StartFeedbackAuditRequest } from '../models';

/**
 * Mirrors App\Http\Controllers\FeedbackAuditController — the feedback audit report
 * (Brafton errors vs client changes), written as a Google Doc in the user's Drive.
 * Runs in the background: start it, then poll the run for the document link.
 *
 * Google problems answer 409/422 with `{ message, reason }` like the exports:
 * `not_connected` / `reconnect_required` (reconnect also covers a grant that
 * can't read Google Docs yet), or `google_api_failed` for a doc link the user
 * can't open.
 */
@Injectable({ providedIn: 'root' })
export class FeedbackAuditService extends FeedbackApiBase {
  /** POST /v1/feedback-audits — starts the audit; resolves to the new run. */
  startAudit(request: StartFeedbackAuditRequest): Observable<FeedbackAuditRun> {
    return this.http
      .post<DataEnvelope<FeedbackAuditRun>>(this.url('feedback-audits'), request)
      .pipe(map((response) => response.data));
  }

  /** GET /v1/feedback-audits/{runId} — the run's progress. */
  getAudit(runId: string): Observable<FeedbackAuditRun> {
    return this.http
      .get<DataEnvelope<FeedbackAuditRun>>(this.url(`feedback-audits/${runId}`))
      .pipe(map((response) => response.data));
  }
}
